import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ArrayDataCard } from 'src/app/interfaces/array-data-card';

@Component({
  selector: 'app-interactable-display-list',
  templateUrl: './interactable-display-list.component.html',
  styleUrls: ['./interactable-display-list.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

// This component is tricky to implement. We need to compose a card collection before passing
// it to this component, however this complicates things, due to having an extra layer of separation
// between the Card collection and the collection the Card collection was composed from. If a user
// clicks a card, we can handle the Card with respect to the Card collection, but it becomes more difficult
// to handle the original collection the Card was derived from.

// Think about this some more before implementing.
export class InteractableDisplayListComponent implements OnInit {
  constructor() {}

  // We can use the ArrayDataCard interface (type) to represent an element to display in the list.
  @Input() arrayDataCardCollection: ArrayDataCard<any>[] = [];

  @Output() cardClick: EventEmitter<{
    index: number;
    ArrayDataCard: ArrayDataCard<any>;
  }> = new EventEmitter<{ index: number; ArrayDataCard: ArrayDataCard<any> }>();

  cardClicked(index: number, ArrayDataCard: ArrayDataCard<any>) {
    this.cardClick.emit({ index, ArrayDataCard });
  }

  ngOnInit(): void {}
}
